import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "首屏直达", href: "#top" },
  { label: "话题标签", href: "#tags" },
  { label: "编号合集", href: "#index" },
  { label: "封面精选", href: "#cover" },
  { label: "为什么信它", href: "#why" },
  { label: "怎么上手", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#faf5ec]/90 backdrop-blur border-b border-[#ead9bd]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="group flex cursor-pointer items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#e4562b] text-lg font-bold text-white">
            瓜
          </span>
          <span className="leading-none">
            <span className="block text-xl font-bold tracking-tight text-[#2a2016]">
              吃瓜地址
            </span>
            <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.28em] text-[#b0843f]">
              Chigua · Direct
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap text-sm text-[#6b5d48] transition-colors hover:text-[#e4562b]"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#top"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-[#d8c3a0] px-4 py-2 text-sm text-[#6b5d48] transition-colors hover:border-[#e4562b] hover:text-[#e4562b]"
          >
            <i className="ri-bookmark-line text-base"></i>
            收藏本站
          </a>
          <a
            href="#cover"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-[#e4562b] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#c8421c]"
          >
            开始找瓜
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-[#d8c3a0] text-[#2a2016] lg:hidden"
        >
          <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-[#ead9bd] bg-[#faf5ec] lg:hidden">
          <nav className="mx-auto flex max-w-[1240px] flex-col gap-1 px-4 py-3 md:px-6">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-lg px-3 py-2.5 text-[15px] text-[#2a2016] hover:bg-[#f0e3cd]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#cover"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#e4562b] px-5 py-2.5 text-sm font-semibold text-white"
            >
              开始找瓜
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}